import { MagnifyingGlass, CaretLeft, CaretRight } from "@phosphor-icons/react";

export default function ListControls({
  q, onQ, filters = [], pagination, onPageChange, total, placeholder = "Search...", testid = "list-controls",
}) {
  return (
    <div className="surface p-3 mb-4 flex flex-wrap items-center gap-3" data-testid={testid}>
      <div className="flex items-center gap-2 flex-1 min-w-[200px]">
        <MagnifyingGlass size={14} className="text-muted-foreground" />
        <input
          className="bg-transparent outline-none text-sm flex-1"
          placeholder={placeholder}
          value={q}
          onChange={(e) => onQ(e.target.value)}
          data-testid={`${testid}-search`}
        />
      </div>
      {filters.map((f) => (
        <div key={f.key} className="flex items-center gap-2">
          <span className="label-xs">{f.label}</span>
          <select
            className="text-xs border border-border px-2 py-1 bg-card"
            value={f.value}
            onChange={(e) => f.onChange(e.target.value)}
            data-testid={`${testid}-filter-${f.key}`}
          >
            <option value="">ALL</option>
            {f.options.map((o) => (
              <option key={o.value || o} value={o.value ?? o}>{o.label ?? o}</option>
            ))}
          </select>
        </div>
      ))}
      {pagination && (
        <div className="flex items-center gap-3 mono text-xs">
          <span>
            {((pagination.page - 1) * pagination.page_size) + 1}
            –
            {Math.min(pagination.page * pagination.page_size, total)} of {total}
          </span>
          <div className="flex">
            <button
              className="btn btn-ghost btn-sm"
              disabled={pagination.page <= 1}
              onClick={() => onPageChange(pagination.page - 1)}
              data-testid={`${testid}-prev`}
            >
              <CaretLeft size={12} />
            </button>
            <button
              className="btn btn-ghost btn-sm"
              disabled={pagination.page >= pagination.pages}
              onClick={() => onPageChange(pagination.page + 1)}
              data-testid={`${testid}-next`}
            >
              <CaretRight size={12} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export const STATUS_OPTS = {
  driver: ["available", "on_route", "off_duty"],
  order: ["pending", "assigned", "in_transit", "delivered", "cancelled"],
  invoice: ["draft", "sent", "paid", "overdue", "void"],
  task: ["todo", "in_progress", "done"],
  priority: ["low", "medium", "high"],
};
